import VideoPlayerModal from './VideoPlayerModal';

export default VideoPlayerModal;
